"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-quote-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M9.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C9.498 10.202 8 12.161 8 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93H9.987zM16.987 13.746c.087-1.412 1.008-2.161 3.082-2.42V10C16.498 10.202 15 12.161 15 14.784c0 1.787.864 2.968 2.448 2.968 1.296 0 2.16-.864 2.16-2.075 0-1.095-.547-1.758-1.498-1.93h-1.123z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-quote-on.js
// module id = 1893
// module chunks = 0